const VerifyMail = ({
  width = 88,
  height = 88,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        fill="url(#paint0_linear_1050_35473)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        stroke="url(#paint1_linear_1050_35473)"
      />
      <g filter="url(#filter0_d_1050_35473)">
        <rect x="16" y="16" width="56" height="56" rx="28" fill="white" />
        <rect
          x="16.5"
          y="16.5"
          width="55"
          height="55"
          rx="27.5"
          stroke="#E2E4E9"
        />
        <path
          d="M54.5 46.1008H52.4V39.0007L44.0756 46.4557L35.6 38.9776V51.3508H46.1V53.4508H34.55C34.2715 53.4508 34.0045 53.3402 33.8075 53.1432C33.6106 52.9463 33.5 52.6793 33.5 52.4008V35.6008C33.5 35.3223 33.6106 35.0552 33.8075 34.8583C34.0045 34.6614 34.2715 34.5508 34.55 34.5508H53.45C53.7285 34.5508 53.9955 34.6614 54.1925 34.8583C54.3894 35.0552 54.5 35.3223 54.5 35.6008V46.1008ZM36.1365 36.6508L44.064 43.6459L51.8771 36.6508H36.1365ZM51.35 54.5008L47.6372 50.788L49.1229 49.3033L51.35 51.5314L55.0628 47.8186L56.5475 49.3033L51.35 54.5008Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1050_35473"
          x="12"
          y="14"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1050_35473"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1050_35473"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1050_35473"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" stopOpacity="0.48" />
          <stop offset="1" stopColor="#F7F8F8" stopOpacity="0" />
          <stop offset="1" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1050_35473"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" />
          <stop offset="0.765625" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default VerifyMail;
